<template>
    <div class="loader">
        <div class="loader__card" />
        <div class="loader__card" />
        <div class="loader__card" />
    </div>
</template>

<style lang="less" src="./BaseLoader.less" />
